import { Cerrar_CorteMutationFn } from "src/gql/schema"
import { RenderSnackbarProps } from "src/shared/hooks/useSnackbar"

export interface CreateCerrarCorteParams {
    cerrarCorteMutate: Cerrar_CorteMutationFn
    usuario_id: string
    efectivo_ingresado: number
    hotel_id: string
    showSnackbar: (params: RenderSnackbarProps) => void
    navigate: (path: string) => void
    setisCerrarCorteLoading: (value: boolean) => void
    setOpenImpresion: (value: boolean) => void
}

export interface CerrarCorteArgs {
    corte_id?: string
    folio?: string
}

export type CerrarCorteFn = (args: CerrarCorteArgs) => Promise<void>

// Cierra un corte existente; navega a /u cuando el backend confirma el cierre
export const createCerrarCorte = ({
    cerrarCorteMutate,
    usuario_id,
    efectivo_ingresado,
    hotel_id,
    showSnackbar,
    navigate,
    setisCerrarCorteLoading,
    setOpenImpresion,
}: CreateCerrarCorteParams): CerrarCorteFn => {
    return async ({ corte_id }: CerrarCorteArgs): Promise<void> => {
        try {
            const { data: res } = await cerrarCorteMutate({
                variables: {
                    datos_corte: {
                        corte_id: corte_id || "",
                        usuario_cierra_corte: usuario_id,
                        efectivo_ingresado,
                    },
                    hotel_id,
                },
            })
            setisCerrarCorteLoading(false)
            if (res) {
                showSnackbar({
                    title: "Corte realizado",
                    text: `Se realizó el corte de turno exitosamente`,
                    status: "success",
                })
                navigate("/u")
            } else {
                showSnackbar({
                    title: "Error al crear corte",
                    text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente.",
                    status: "error",
                })
                setOpenImpresion(false)
            }
        } catch (error) {
            console.log("error, ", error)
            showSnackbar({
                title: "Error al crear corte",
                text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente.",
                status: "error",
            })
            setisCerrarCorteLoading(false)
            setOpenImpresion(false)
        }
    }
}
